import { DestroyRef, signal, type WritableSignal } from '@angular/core';
import {
  clampVaultTablePageSize,
  readVaultItemsPerPageFromPreferences,
  VAULT_TABLE_PAGINATION_UPDATED_EVENT,
} from '@nebula/shared-vault/data-access';

/**
 * `destroyRef` debe inyectarse en un campo/constructor del componente (contexto de
 * inyección) y pasarse aquí; NO llamar `inject(DestroyRef)` dentro de `ngOnInit` (NG0203).
 */
export function subscribeVaultTablePageSizePreference(
  destroyRef: DestroyRef,
  onApply: (size: number) => void,
): void {
  bindVaultTablePageSizeToPreferences(createVaultTablePageSizeSignal(), destroyRef, onApply);
}

export function createVaultTablePageSizeSignal(): WritableSignal<number> {
  return signal(readVaultItemsPerPageFromPreferences());
}

export function bindVaultTablePageSizeToPreferences(
  pageSize: WritableSignal<number>,
  destroyRef: DestroyRef,
  onApply?: (size: number) => void,
): void {
  if (typeof globalThis.window === 'undefined') return;

  const apply = (value?: number) => {
    const next = clampVaultTablePageSize(value ?? readVaultItemsPerPageFromPreferences());
    pageSize.set(next);
    onApply?.(next);
  };

  const handler = (event: Event) => {
    const detail = (event as CustomEvent<{ pageSize?: number }>).detail;
    apply(detail?.pageSize);
  };

  globalThis.window.addEventListener(VAULT_TABLE_PAGINATION_UPDATED_EVENT, handler);
  destroyRef.onDestroy(() =>
    globalThis.window.removeEventListener(VAULT_TABLE_PAGINATION_UPDATED_EVENT, handler),
  );
}
